import { useLoading } from 'hooks/UseLoading'
import { useAuth } from 'hooks/UseAuth'
import client, { GuestRemovalType } from 'api/client'
import { WorkspaceService } from 'api/services/WorkspaceService'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { handleErrorResponseWithMessage } from 'api/utils/handleErrorResponseWithMessage'
import { showToastMessage } from 'common/ToastMessage/ShowToastMessage'
import { UserService } from 'api/clients/UserService'
import { useWorkspaces } from 'hooks/useWorkspaces'
import { Workspace } from 'types'

export const useLeaveWorkspace = ({
  workspace,
  onLeave,
  close,
}: {
  workspace: Workspace
  onLeave?: () => void
  close: () => void
}) => {
  const auth = useAuth()
  const workspaces = useWorkspaces()

  const leaveWorkspaceCallback = async () => {
    if (!auth?.id) return

    const response = workspace.guest
      ? await client.removeGuestFromWorkspace(workspace.key, auth?.id, GuestRemovalType.simple)
      : await WorkspaceService.leave(workspace.key)

    if (response && response.type !== SUCCESS_RESPONSE_TYPE) {
      handleErrorResponseWithMessage(response.data.errors)(response)
    }

    if (response && response.type === SUCCESS_RESPONSE_TYPE) {
      UserService.setWorkspaces(workspaces.filter((w) => w.key !== workspace.key))
      showToastMessage('You have left the workspace!', 'success')
      close()
      onLeave?.()
    }
  }

  const [leaveWorkspace, leaveWorkspaceLoading] = useLoading(leaveWorkspaceCallback)

  return {
    leaveWorkspace,
    leaveWorkspaceLoading,
  }
}
